<div>
  <div
    class="search-bar"
    fxLayout="row"
    fxLayoutAlign="space-between"
    fxLayoutGap="16px"
  >
    <pt-search-field fxFlex>
      <input
        #search
        matInput
        placeholder="Search by title, lab, patient, or status"
        (keyup)="searchLabJobs(search.value)"
      />
      <button mat-icon-button class="sm:!hidden" (click)="addNewLabJob()">
        <mat-icon class="add-lab-job-icon">add</mat-icon>
      </button>
    </pt-search-field>
    <button
      mat-raised-button
      class="!hidden sm:!inline-flex"
      color="primary"
      (click)="addNewLabJob()"
    >
      Create Lab Job
    </button>
  </div>

  <div
    fxLayout="column"
    fxLayoutAlign="start start"
    fxLayout.gt-sm="row"
    fxLayoutAlign.gt-sm="start center"
    fxLayoutGap="16px"
  >
    <mat-button-toggle-group
      [value]="statusFilter$ | async"
      [hideSingleSelectionIndicator]="true"
      (change)="updateStatusFilter($event.value)"
    >
      <mat-button-toggle value="sending">Sending</mat-button-toggle>
      <mat-button-toggle value="sent">Sent</mat-button-toggle>
      <mat-button-toggle value="received">Received</mat-button-toggle>
      <mat-button-toggle value="issued">Issued</mat-button-toggle>
    </mat-button-toggle-group>

    <div class="hidden flex-1 sm:block"></div>

    <div
      class="lab-jobs-filter-container"
      fxLayout="row"
      fxLayoutAlign.gt-sm="end center"
      fxLayoutGap="16px"
    >
      <div class="mat-body-2">
        <mat-form-field subscriptSizing="dynamic" class="w-36">
          <mat-label>Sort By</mat-label>
          <mat-select
            #sort="matSort"
            matSort
            [formControl]="sortControl"
            [matSortActive]="activeSort$ | async"
            [matSortDirection]="activeSortDirection$ | async"
            (matSortChange)="sortChange($event)"
          >
            <mat-option
              *ngFor="let option of sortOptions; trackBy: trackByOption"
              [value]="option"
            >
              <span mat-sort-header="{{ option.id }}" [disableClear]="true">
                {{ option.label }}
              </span>
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>
</div>

<div class="lab-job-list-container mat-elevation-z1">
  <mat-toolbar>
    <div fxLayout="row" fxLayoutAlign="center stretch">
      <div class="checkbox">
        <mat-checkbox
          color="primary"
          [indeterminate]="selectionList.isSomeSelected$ | async"
          [checked]="selectionList.isAllSelected$ | async"
          (change)="selectionList.toggleAllSelected()"
        />
      </div>

      <ng-container *ngIf="(selectionList.isNoneSelected$ | async) === false">
        <mat-divider [vertical]="true" />

        <div fxFlex>
          <button
            mat-icon-button
            matTooltip="Change Status"
            matTooltipShowDelay="500"
            [matMenuTriggerFor]="statusMenu"
          >
            <mat-icon>low_priority</mat-icon>
          </button>

          <mat-menu #statusMenu="matMenu">
            <button
              *ngFor="let status of statuses; trackBy: trackByStatus"
              mat-menu-item
              (click)="updateStatus(status)"
            >
              {{ status | titlecase }}
            </button>
          </mat-menu>
        </div>
      </ng-container>
    </div>
  </mat-toolbar>
  <div class="lab-job-list">
    <mat-progress-bar
      *ngIf="dataSource.loading$ | async"
      mode="indeterminate"
    />

    <pr-empty-state
      *ngIf="emptySearch$ | async"
      image="search"
      title="search results"
      [searchInputValue]="search.value"
    />

    <pr-empty-state
      *ngIf="emptyState$ | async"
      image="list"
      [title]="'lab jobs ' + (statusFilter$ | async)"
    />

    <pr-lab-job-list-display
      [sort]="sort"
      [dataSource]="dataSource"
      [selectionList]="selectionList"
      [(selectedItem)]="selectedLabJob"
      (selectedItemChange)="editLabJob($event)"
    />
  </div>
</div>
